import palette from '../../../../theme/palette';

export default () => ({
  paper: {
    width: '100%',
    padding: '16px',
    margin: '6px',
  },

  divider: {
    margin: '1rem 0 1rem 0',
  },

  filterInput: {
    width: '100%',
    '@media (min-width: 1366px)': {
      width: '17.5rem',
    },
    '@media (min-width: 1600px)': {
      width: '24rem',
    },
    '& label': {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: '0.6rem',
      '@media (min-width: 1200px)': {
        fontSize: '1rem',
      },
    },
    '& .MuiSvgIcon-root': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  buttonClearFilter: {
    marginRight: '1rem',
  },
  selectLabel: {
    color: 'rgba(0, 0, 0, 0.6)',
    '&.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
  datePicker: {
    '& .MuiSvgIcon-root': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
});

export const BeneficiosMGMTableRowStyles = {
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableCellPadding: {
    padding: '0',
  },
  disabledButton: {
    color: 'grey',
    cursor: 'not-allowed',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  tableRow: {
    backgroundColor: palette.background.default,
    width: '100%',
    display: 'table',
    height: '82px',
  },
  textCapitalize: {
    textTransform: 'capitalize',
  },

  tableCell: {
    fontSize: '14px',
    lineHeight: '18px',
    whiteSpace: 'nowrap',
    color: palette.text.secondary,
    width: '10%',
    border: '1px solid #ccc',
  },

  tableCellText: {
    fontSize: '14px',
    lineHeight: '18px',
    whiteSpace: 'nowrap',
    color: palette.text.secondary,
  },

  tableContainer: {
    border: '1px solid #ccc',
  },

  headerIndicado: {
    backgroundColor: palette.secondary[300],
    fontWeight: 'bold',
    color: '#333',
    border: '1px solid #ccc',
    textAlign: 'center',
  },

  headerIndicador: {
    backgroundColor: palette.secondary[200],
    fontWeight: 'bold',
    color: '#333',
    border: '1px solid #ccc',
    textAlign: 'center',
  },

  headerCell: {
    border: '1px solid #ccc',
  },
};
